import { ShieldAlert, MessageCircle, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SupportChat from "@/components/SupportChat";

const SuspendedAccountScreen = ({ restaurantName, restaurantId }: { restaurantName?: string; restaurantId?: string }) => {
  const navigate = useNavigate();
  const [showChat, setShowChat] = useState(false);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center space-y-6">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-destructive/10 mx-auto">
          <ShieldAlert className="h-10 w-10 text-destructive" />
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold font-display text-foreground">
            Conta Suspensa
          </h1>
          {restaurantName && (
            <p className="text-sm text-muted-foreground font-medium">{restaurantName}</p>
          )}
        </div>

        <div className="rounded-xl border border-destructive/20 bg-destructive/5 p-5 text-left space-y-3">
          <p className="text-sm text-foreground leading-relaxed">
            Sua conta foi suspensa por violação dos nossos{" "}
            <a href="/termos-de-uso" className="text-primary underline hover:no-underline" target="_blank">
              Termos de Uso
            </a>.
          </p>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Durante a suspensão, o acesso ao painel e ao cardápio digital está bloqueado. 
            Se você acredita que isso foi um erro, entre em contato com nosso suporte.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <Button
            onClick={() => setShowChat(true)}
            className="w-full h-11 gap-2"
            variant="default"
          >
            <MessageCircle className="h-4 w-4" />
            Falar com o Suporte
          </Button>
          <Button
            onClick={handleLogout}
            variant="ghost"
            className="w-full h-10 gap-2 text-muted-foreground"
          >
            <LogOut className="h-4 w-4" />
            Sair da conta
          </Button>
        </div>
      </div>

      {showChat && restaurantId && <SupportChat restaurantId={restaurantId} />}
    </div>
  );
};

export default SuspendedAccountScreen;
